// extracted by mini-css-extract-plugin
module.exports = {"shadow":"Radio_shadow__Ows93","higgs-radio-div":"Radio_higgs-radio-div__3G2VE","marker":"Radio_marker__aGmiy"};